import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        if (this.props.onError) {
            this.props.onError(error, info);
        }
        // Minimal fallback logging; production should send to a logging service
        // Avoid including sensitive data
        console.error('UI ErrorBoundary:', error);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-[200px] flex items-center justify-center text-center p-6">
                    <div>
                        <h2 className="text-xl font-semibold text-red-600">Something went wrong.</h2>
                        <p className="text-gray-600 mt-2">Please try again or refresh the page.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;


